import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
            <h1 style={{ textAlign: 'center' }}>Privacy Policy</h1>
            <p>
                This privacy policy (“Policy”) describes how the personally identifiable information
                (“Personal Information”) you may provide in the <strong>“LtW” mobile application</strong>
                (“Mobile Application”), the <strong>Lead the Way web application</strong> (“Web
                Application”) and any of their related products and services (collectively,
                “Services”) is collected, protected and used. It also describes the choices available
                to you regarding our use of your Personal Information and how you can access and
                update this information.
            </p>
            <p>
                This Policy is a legally binding agreement between you (“User”, “you” or “your”) and this
                Mobile Application developer (“Operator”, “we”, “us” or “our”). If you are entering into
                this Policy on behalf of a business or other legal entity, you represent that you have the
                authority to bind such entity to this Policy. By accessing and using the Mobile Application
                and Services, you acknowledge that you have read, understood, and agree to be bound by
                the terms of this Policy.
            </p>
            <h2>Table of Contents</h2>
            <ol>
                <li>Collection of Personal Information</li>
                <li>Cookies</li>
                <li>Use and Processing of Collected Information</li>
                <li>Disclosure of Information</li>
                <li>Retention of Information</li>
                <li>Privacy of Children</li>
                <li>Push Notifications</li>
                <li>Links to Other Resources</li>
                <li>Information Security</li>
                <li>Data Breach</li>
                <li>Changes and Amendments</li>
                <li>Acceptance of This Policy</li>
                <li>Contacting Us</li>
            </ol>
            <h2>1. Collection of Personal Information</h2>
            <p>
                You can access and use the Mobile Application and Services without telling us who you are
                or revealing any information by which someone could identify you as a specific,
                identifiable individual. If, however, you wish to use some of the features offered in the
                Mobile Application, you may be asked to provide certain Personal Information (for example,
                your name and email address).
            </p>
            <h2>2. Cookies</h2>
            <p>
                The Web Application uses only strictly necessary, first-party cookies. They are
                required to sign you in and keep your session secure, and they are not used for
                analytics, advertising, or any other form of tracking:
            </p>
            <ul>
                <li>
                    <strong>authToken</strong> – keeps you signed in to your account. Stored for up
                    to 7 days with the Secure and SameSite=Strict protections.
                </li>
                <li>
                    <strong>userId</strong> – identifies your account during a signed-in session.
                    Same lifetime and protections as authToken.
                </li>
            </ul>
            <p>
                In addition, when you dismiss the cookie notice shown in the Web Application, we
                remember that choice in your browser&apos;s local storage (or in a
                “cookieNoticeAcknowledged” cookie if local storage is unavailable) so the notice is
                not shown to you again. Because all of the above are strictly necessary to provide
                the Services you request, they do not require consent under the EU ePrivacy rules;
                the cookie notice is shown for transparency. You can delete these cookies at any
                time in your browser settings, which will sign you out of the Web Application.
            </p>
            <h2>3. Use and Processing of Collected Information</h2>
            <p>
                We act as a data controller and a data processor when handling Personal Information,
                depending on how the information is used. Our role may differ depending on the situation
                involving Personal Information. We collect and use your Personal Information for purposes
                such as account creation, service provision, and compliance with legal obligations.
            </p>
            <h2>4. Disclosure of Information</h2>
            <p>
                Depending on the requested Services or as necessary to complete any transaction or provide
                any service you have requested, we may share your information with our trusted third
                parties who assist us in operating our Mobile Application and Services.
            </p>
            <h2>5. Retention of Information</h2>
            <p>
                We will retain and use your Personal Information for as long as necessary to comply with
                our legal obligations, resolve disputes, and enforce our agreements unless a longer
                retention period is required or permitted by law.
            </p>
            <h2>6. Privacy of Children</h2>
            <p>
                We do not knowingly collect any Personal Information from children under the age of 13. If
                you are under the age of 13, please do not submit any Personal Information through our
                Mobile Application and Services.
            </p>
            <h2>7. Push Notifications</h2>
            <p>
                We may send you push notifications to your mobile device to provide updates and other
                relevant information.
            </p>
            <h2>8. Links to Other Resources</h2>
            <p>
                The Mobile Application and Services may contain links to other resources that are not owned
                or controlled by us. We are not responsible for the privacy practices of such third parties.
            </p>
            <h2>9. Information Security</h2>
            <p>
                We secure information you provide on computer servers in a controlled, secure environment,
                protected from unauthorized access, use, or disclosure.
            </p>
            <h2>10. Data Breach</h2>
            <p>
                In the event we become aware that the security of the Mobile Application and Services has
                been compromised or Personal Information has been disclosed to unrelated third parties as
                a result of external activity, we will take necessary steps to address the situation.
            </p>
            <h2>11. Changes and Amendments</h2>
            <p>
                We reserve the right to modify this Policy at any time, effective upon posting of an updated
                version in the Mobile Application. When we do, we will revise the updated date at the bottom
                of this page.
            </p>
            <h2>12. Acceptance of This Policy</h2>
            <p>
                You acknowledge that you have read this Policy and agree to all its terms and conditions.
                By accessing and using the Mobile Application and Services, you agree to be bound by this
                Policy.
            </p>
            <h2>13. Contacting Us</h2>
            <p>
                If you have any questions about this Policy, please contact us at info@leadtheway.sk
            </p>
        </div>
    );
};

export default PrivacyPolicy;
